export default __webpack_public_path__ + "/assets/card_02-hover.png";